import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const ProfileItem = ({ label, className, children, ...props }) => {
  const cn = useClassNames(() => ['mb-6', 'w-full', className], [className]);
  return (
    <li data-component="ProfileItem" className={cn} {...props}>
      <div className="font-semibold mb-2">{label}</div>
      <div>{children}</div>
    </li>
  );
};

ProfileItem.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.node,
};

ProfileItem.defaultProps = {
  className: null,
};

export default ProfileItem;
